import { useState } from 'react';
import PropTypes from 'prop-types';

import PersonalBillingAddressForm from './PersonalBillingAddressForm';
import CompanyBillingAddressForm from './CompanyBillingAddressFrom';
import SlidingSelector from '../../components/common/SlidingSelector';

const BillingAddressFormContainer = ({
  initialValues,
  onSubmit,
  cancelable,
  onCancel,
}) => {
  const [billingAddressType, setBillingAddressType] = useState('personal');
  return (
    <>
      <SlidingSelector
        selected={billingAddressType}
        options={['personal', 'company']}
        onChange={setBillingAddressType}
      />
      {billingAddressType === 'personal' && (
        <PersonalBillingAddressForm
          initialValues={initialValues}
          onSubmit={onSubmit}
          cancelable={cancelable}
          onCancel={onCancel}
        />
      )}

      {billingAddressType === 'company' && (
        <CompanyBillingAddressForm
          // initialValues={initialValues}
          onSubmit={onSubmit}
          cancelable={cancelable}
          onCancel={onCancel}
        />
      )}
    </>
  );
};

BillingAddressFormContainer.propTypes = {
  initialValues: PropTypes.shape({
    // personal billing address only
    title: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    // TODO: Handle company billing address
    // initial values

    // common
    email: PropTypes.string.isRequired,
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    additionalInformation: PropTypes.string.isRequired,
  }),
  cancelable: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default BillingAddressFormContainer;
